import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { orderFromBundle } from '../../util/apiUtils';
import CreateOrderLoadingModal from './CreateOrderLoadingModal';
import { getBillingTypeDisplayName } from '../../util/gearOrderUtil';
import '../bundles.css';

const SavedBundlesAccordion = ({ gearOrder, savedBundles, setGearOrder }) => {
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);

	/**
	 * Send a request to build a new order from the bundle and then redirect to the patient step.
	 */
	const onBundleSelection = (bundle) => {
		setLoading(true);
		setError(false);

		const bundleOrderRequest = {
			gearBundleId: bundle.gearBundleId,
			gearOrderId: bundle.gearOrderId,
			practAgreement: !!gearOrder?.practAgreement
		};

		orderFromBundle(bundleOrderRequest)
			.then((gearOrder) => {
				if (gearOrder?.id) {
					gearOrder.bundleTemplate = bundle;
					setGearOrder(gearOrder);
					history.push(`/order/${gearOrder.id}/patient`);
				} else {
					setError(true);
				}
			})
			.catch((err) => setError(true))
			.finally(() => {
				setLoading(false);
			});
	};

	const closeModal = () => {
		setLoading(false);
		setError(false);
	};

	// The style used for the Orderable Item table headings
	const headerStyle = {
		position: 'sticky',
		top: '0',
		zIndex: '10',
		background: 'white',
		paddingTop: '5px',
		borderBottom: '1px solid black'
	};
	let backgroundHex = '#7DACA7';

	return (
		<>
			<div className="panel" style={{ marginBottom: '5px', borderColor: backgroundHex }}>
				<div className="panel-heading" role="tab" id="heading-bundle" style={{ padding: '0' }}>
					<h4 className="panel-title" style={{ backgroundColor: backgroundHex }}>
						<a
							role="button"
							data-toggle="collapse"
							data-parent="#accordion"
							href="#collapse-bundle"
							aria-expanded="true"
							aria-controls="collapse-bundle"
							style={{ padding: '10px 15px', backgroundColor: backgroundHex }}
						>
							<span className="fa fa-folder-collapse pr-10"></span>
							Customized Genova Profiles
						</a>
					</h4>
				</div>
				<div
					id="collapse-bundle"
					className="panel-collapse collapse in"
					role="tabpanel"
					aria-labelledby="heading-bundle"
					aria-expanded="true"
				>
					{!!savedBundles?.length && (
						<div
							className="panel-body"
							style={{ maxHeight: '350px', overflowY: 'auto', paddingTop: '0', paddingBottom: '5px' }}
						>
							<div>
								<table
									className="table-condensed table-hover bundle-list"
									style={{ width: '100%', tableLayout: 'fixed' }}
								>
									<thead style={{ cursor: 'default', verticalAlign: 'bottom' }}>
										<tr>
											<th className="col-xs-3" style={headerStyle}>
												Custom Profile
											</th>
											<th style={headerStyle}>Product(s)</th>
										</tr>
									</thead>
									<tbody>
										{savedBundles.map((bundle) => {
											const billingMethodDisplayName =
												bundle.billingMethod === process.env.REACT_APP_BILLING_SKIP
													? null
													: getBillingTypeDisplayName(bundle.billingMethod);
											return (
												<tr key={bundle.gearBundleId} onClick={() => onBundleSelection(bundle)}>
													<td>
														{bundle.name}
														{!!billingMethodDisplayName && (
															<small className="bundle-billing-method">
																{billingMethodDisplayName}
															</small>
														)}
													</td>
													<td style={{ verticalAlign: 'top' }}>
														<div className="row">
															<div
																className="col-xs-10 bundle-products-name-list"
																title={bundle.productNamesString}
															>
																{bundle.productNamesString}
															</div>
															<div
																className="col-xs-2 pull-right"
																style={{ padding: '0' }}
															>
																<Link
																	to={{
																		pathname: `/custom-profile/edit/${bundle.gearBundleId}`,
																		state: { gearOrder }
																	}}
																	className="text-primary btn-link text-right"
																	title={`Edit ${bundle.name} custom profile`}
																	style={{
																		border: 'none',
																		padding: '0 15px 0 0',
																		width: '100%',
																		display: 'inline-block'
																	}}
																	onClick={(event) => event.stopPropagation()}
																>
																	<span className="fa fa-pencil-square-o"></span>
																</Link>
															</div>
														</div>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</div>
					)}
					<div className="panel-footer" style={{ cursor: 'initial' }}>
						<div className="text-center">
							<Link
								to={{
									pathname: `/custom-profile/new/${gearOrder?.practitioner?.gsdlNo}`,
									state: { gearOrder }
								}}
								title="Create a new custom profile"
							>
								{savedBundles?.length
									? 'Create a new custom profile'
									: 'You have no saved custom profiles. Create your new saved custom profile today!'}
							</Link>
						</div>
					</div>
				</div>
			</div>
			<CreateOrderLoadingModal loading={loading} error={error} closeModal={closeModal} />
		</>
	);
};

export default SavedBundlesAccordion;
